<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.brand" style="width: 120px" filterable clearable>
                <el-option v-for="b in brandList" :label="b.brand_name" :value="b.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="是否跳转">
              <el-select v-model="searchForm.islink" clearable style="width: 100px">
                <el-option label="不跳转" :value="0" />
                <el-option label="跳转" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="跳转类型">
              <el-select v-model="searchForm.type" clearable style="width: 100px">
                <el-option label="免费报价" :value="0" />
                <el-option label="0元设计" :value="1" />
                <el-option label="预约到店" :value="2" />
                <el-option label="线下活动" :value="3" />
                <el-option label="直播活动" :value="4" />
                <el-option label="案例" :value="5" />
                <el-option label="装修攻略" :value="6" />
                <el-option label="晒家" :value="7" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加轮播</el-button>
            </el-form-item>
          </el-form>
          <div v-loading="loading" class="card-content">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%;margin-bottom: 20px"
            >
              <el-table-column
                label="轮播图"
                align="center"
                width="120"
              >
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.imgurl"
                    fit="cover"
                    style="height: 40px;"
                    :preview-src-list="[scope.row.imgurl]"
                  />
                </template>
              </el-table-column>
              <el-table-column
                label="优先级"
                width="200"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.xuhao }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="brandname"
                label="品牌"
                width="200"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="经销商"
                width="200"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.delid!=='0'">{{ scope.row.delname }}</span>
                  <span v-if="scope.row.delid==='0'">公共</span>
                </template>
              </el-table-column>
              <el-table-column
                label="是否跳转"
                width="200"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.islink===0">不跳转</span>
                  <span v-if="scope.row.islink===1">跳转</span>
                </template>
              </el-table-column>
              <el-table-column
                label="跳转类型"
                min-width="200"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.type===0&&scope.row.islink===1">免费报价</span>
                  <span v-if="scope.row.type===1&&scope.row.islink===1">0元设计</span>
                  <span v-if="scope.row.type===2&&scope.row.islink===1">预约到店</span>
                  <span v-if="scope.row.type===3&&scope.row.islink===1">线下活动</span>
                  <span v-if="scope.row.type===4&&scope.row.islink===1">直播活动</span>
                  <span v-if="scope.row.type===5&&scope.row.islink===1">案例</span>
                  <span v-if="scope.row.type===6&&scope.row.islink===1">装修攻略</span>
                  <span v-if="scope.row.type===7&&scope.row.islink===1">晒家</span>
                  <span v-if="scope.row.islink===0">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="200"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button :disabled="scope.row.delid!=='0'" icon="el-icon-edit" size="mini" @click="editRow(scope.row)">修改</el-button>
                  <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="dialogVisible"
      width="600px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" size="small" :model="editForm" label-width="80px" :rules="dilogrules" style="padding:15px 30px 15px 15px;">
        <el-form-item label="优先级" prop="xuhao">
          <el-input-number v-model="editForm.xuhao" :min="0" :max="999" ></el-input-number>
          <span style="color:#99a9bf;font-size:12px;margin-left: 10px">越小越优先</span>
        </el-form-item>
        <el-form-item label="品牌" prop="bid">
          <el-select v-model="editForm.bid" filterable clearable>
            <el-option v-for="b in brandList" :label="b.brand_name" :value="b.brand_id" />
          </el-select>
        </el-form-item>
<!--        <el-form-item label="是否缺省" prop="isdef">-->
<!--          <el-switch v-model="editForm.isdef">-->
<!--          </el-switch>-->
<!--        </el-form-item>-->
        <el-form-item label="轮播图" prop="img">
          <span style="color:#99a9bf;"><i class="el-icon-warning"></i> 建议上传700*280尺寸的图片</span>
          <SingleImg :key="imgkey" v-model="editForm.img" :oldurl="editForm.oldimgurl" :size="[375,140]" />
        </el-form-item>
        <el-form-item label="是否跳转" prop="islink">
          <el-radio-group v-model="editForm.islink">
            <el-radio :label="0">不跳转</el-radio>
            <el-radio :label="1">跳转</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="editForm.islink === 1" label="跳转类型" prop="type">
          <el-select v-model="editForm.type" clearable style="width: 200px" @change="updatekey">
            <el-option label="免费报价" :value="0" />
            <el-option label="0元设计" :value="1" />
            <el-option label="预约到店" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button :loading="eidtLoading" type="primary" @click="SubForm()">立即提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import SingleImg from '@/components/upload/SingleImg'
import { getDelShopBannerList, editDelShopBanner, delDelShopBanner } from '@/api/dealer'
import { getBrandSeriesList } from '@/api/pub'

export default {
  name: 'xcxbanner',
  components: {
    SingleImg
  },
  data() {
    return {
      delid: '',
      brandList: [],
      searchForm: {
        brand: null,
        islink: null,
        type: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      dilogrules: {
        islink: [{ required: true, message: '请选择是否跳转', trigger: 'change' }],
        type: [{ required: true, message: '请选择跳转类型', trigger: 'change' }],
        dataid: [{ required: true, message: '请选择跳转目标', trigger: 'change' }],
        xuhao: [{ required: true, message: '请输入优先级', trigger: 'blur' }],
        img: [{ required: true, message: '请上传轮播图片', trigger: 'change' }],
        bid: [{ required: true, message: '请选择品牌', trigger: 'change' }]
      },
      editForm: {
        dsbid: 0,
        bid: null,
        islink: null,
        type: null,
        dataid: null,
        xuhao: '',
        img: null,
        isdef: false,
        oldimgurl: ''
      },
      skipid: null,
      editTitle: '',
      dialogVisible: false,
      eidtLoading: false,
      imgkey: '',
      bannerskipkey: ''
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getBrandList()
    this.getData()
  },
  methods: {
    getBrandList() {
      getBrandSeriesList().then(response => {
        let _brandList = []
        if (this.user.dGroupid === 1) { // 杭州乔金斯
          for (const b of response.data) {
            if (b.brand_id === 3) {
              _brandList.push(b)
            }
          }
        } else if (this.user.dGroupid === 2) { // 耐思迪
          for (const b of response.data) {
            if (b.brand_id === 1 || b.brand_id === 2) {
              _brandList.push(b)
            }
          }
        }
        this.brandList = _brandList
      })
    },
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        islink: this.searchForm.islink,
        type: this.searchForm.type,
        bid: this.searchForm.brand,
        groupid: this.user.dGroupid
      }
      getDelShopBannerList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    updatekey() {
      this.bannerskipkey = new Date().getTime().toString()
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    editRow(row) {
      if (row === null) {
        this.editTitle = '添加轮播'
        this.editForm.dsbid = 0
        this.editForm.islink = null
        this.editForm.bid = null
        this.editForm.type = null
        this.editForm.xuhao = ''
        this.editForm.img = null
        this.editForm.dataid = null
        this.editForm.isdef = false
        this.editForm.oldimgurl = ''
        this.skipid = null
      } else {
        this.editTitle = '编辑轮播'
        this.editForm.dsbid = row.dsbid
        this.editForm.bid = row.bid
        this.editForm.islink = row.islink
        this.editForm.type = row.type
        this.editForm.xuhao = row.xuhao
        this.editForm.img = { imgid: row.imgid, imgurl: row.imgurl }
        this.editForm.oldimgurl = row.imgurl
        this.editForm.isdef = row.isdef === 1 ? true : false
        this.skipid = row.dataid
      }
      this.imgkey = (new Date().getTime() + 33).toString()
      this.dialogVisible = true
    },
    SubForm() {
      if (!this.eidtLoading) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.eidtLoading = true
            this.skipid = null
            const data = {
              delid: 0,
              bid: this.editForm.bid,
              dsbid: this.editForm.dsbid,
              islink: this.editForm.islink,
              imgid: this.editForm.img.imgid,
              type: this.editForm.type,
              dataid: this.skipid,
              xuhao: this.editForm.xuhao,
              isdef: this.editForm.isdef ? 1 : 0
            }
            editDelShopBanner(data).then(response => {
              this.eidtLoading = false
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.Search()
              this.dialogVisible = false
            }).catch(() => {
              this.eidtLoading = false
            })
          }
        })
      }
    },
    deleteRow(row) {
      this.$confirm('您确定要删除此轮播吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delDelShopBanner({ dsbid: row.dsbid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>
